import axios from 'axios';

import { ActionType } from '../actionTypes';

import envManager from '../../com/envManager/EnvManager';

import {
    UserDto,
    ErrorDtoFactory,
    FlyerPagesTocEntriesDto,
    FlyerTocDto,
    PageRunsDto
} from '../../dtos';
import {Dispatch} from "redux";
import {Action as TocForPages} from "../actions/tocForPagesActions";
import {Action as FlyerDetailsActions} from "../actions/flyerDetailsActions";
import {FlyerDetailsState} from "../reducers/flyerDetailsReducer";

interface CreateDataForTocDto {
    flyerId: number;
    caption: string;
    pageRuns: PageRunsDto[]
}

interface UpdateDataForTocDto {
    flyerId: number;
    caption: string;
    tocEntryId: number;
    pageRuns: PageRunsDto[]
}

export const createTocForPage = (requestData: CreateDataForTocDto, flyerState: FlyerDetailsState) => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<TocForPages | FlyerDetailsActions>) => {
        dispatch({
            type: ActionType.CREATE_TOC_FOR_PAGE_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            let url = `${envManager.flyerEditorServerAddress}/api/Toc/CreateFlyerTocEntry`;
            let result = await axios.post(url, requestData, config);
            let data = result.data.data;
            const tocPageData: FlyerPagesTocEntriesDto = {
                ...data.toc[0].tocEntryDto,
                pageRange: data.toc[0].pageRuns,
            }
            dispatch({
                type: ActionType.CREATE_TOC_FOR_PAGE_SUCCESS,
                payload: tocPageData
            });
            dispatch({
                type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
                payload: {
                    ...flyerState,
                    toc: [...data.toc]
                }
            });

            dispatch({
                type: ActionType.CREATE_TOC_FOR_PAGE_COMPLETE,
            })
        } catch (err) {
            dispatch({
                type: ActionType.CREATE_TOC_FOR_PAGE_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const updateToc = (requestData: UpdateDataForTocDto, flyerState: FlyerDetailsState) => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<TocForPages | FlyerDetailsActions>) => {
        dispatch({
            type: ActionType.UPDATE_TOC_FOR_PAGE_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            // const request = {
            //     "tocEntryId": tocId,
            //     "caption": caption
            // };
            let url = `${envManager.flyerEditorServerAddress}/api/Toc/UpdateFlyerTocEntry`;
            let result = await axios.post(url, requestData, config);
            let data = result.data.data;
            const tocPageData: FlyerPagesTocEntriesDto = {
                ...data.toc,
            }
            dispatch({
                type: ActionType.UPDATE_TOC_FOR_PAGE_SUCCESS,
                payload: tocPageData
            });

            dispatch({
                type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
                payload: {
                    ...flyerState,
                    toc: [...data.toc]
                }
            });

            dispatch({
                type: ActionType.UPDATE_TOC_FOR_PAGE_COMPLETE,
            })
        } catch (err) {
            dispatch({
                type: ActionType.UPDATE_TOC_FOR_PAGE_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const deleteToc = (tocId: number, flyerState: FlyerDetailsState) => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<TocForPages | FlyerDetailsActions>) => {
        dispatch({
            type: ActionType.DELETE_TOC_FOR_PAGE_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            const request = {
                "tocEntryId": tocId,
            };
            let url = `${envManager.flyerEditorServerAddress}/api/Toc/DeleteFlyerTocEntry`;
            let result = await axios.post(url, request, config);
            let data = result.data;

            const tocPageData: FlyerPagesTocEntriesDto = {
                // ...popupData,
                ...data,
            }

            dispatch({
                type: ActionType.DELETE_TOC_FOR_PAGE_SUCCESS,
                payload: tocPageData
            })

            const newState = flyerState.toc.filter((toc: FlyerTocDto) => {
                return toc.tocEntryDto.id !== tocId
            })

            dispatch({
                type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
                payload: {
                    ...flyerState,
                    toc: newState
                }
            });


            dispatch({
                type: ActionType.DELETE_TOC_FOR_PAGE_COMPLETE,
            })
        } catch (err) {
            dispatch({
                type: ActionType.DELETE_TOC_FOR_PAGE_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}
